// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"6d127748","688":"c9de9106"}[chunkId] + ".chunk.js";
};